import { render, staticRenderFns } from "./ListSchools.vue?vue&type=template&id=412d679d&"
import script from "./ListSchools.vue?vue&type=script&lang=js&"
export * from "./ListSchools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports